__turbopack_context__.v({
  "displayName": "userProfileBadge-module-scss-module__F3_wTq__displayName",
  "mbl": "userProfileBadge-module-scss-module__F3_wTq__mbl",
  "mbm": "userProfileBadge-module-scss-module__F3_wTq__mbm",
  "mbn": "userProfileBadge-module-scss-module__F3_wTq__mbn",
  "mbs": "userProfileBadge-module-scss-module__F3_wTq__mbs",
  "mbx": "userProfileBadge-module-scss-module__F3_wTq__mbx",
  "mbxl": "userProfileBadge-module-scss-module__F3_wTq__mbxl",
  "mbxxl": "userProfileBadge-module-scss-module__F3_wTq__mbxxl",
  "ml": "userProfileBadge-module-scss-module__F3_wTq__ml",
  "mll": "userProfileBadge-module-scss-module__F3_wTq__mll",
  "mlm": "userProfileBadge-module-scss-module__F3_wTq__mlm",
  "mln": "userProfileBadge-module-scss-module__F3_wTq__mln",
  "mls": "userProfileBadge-module-scss-module__F3_wTq__mls",
  "mlx": "userProfileBadge-module-scss-module__F3_wTq__mlx",
  "mlxl": "userProfileBadge-module-scss-module__F3_wTq__mlxl",
  "mlxxl": "userProfileBadge-module-scss-module__F3_wTq__mlxxl",
  "mm": "userProfileBadge-module-scss-module__F3_wTq__mm",
  "mn": "userProfileBadge-module-scss-module__F3_wTq__mn",
  "mrl": "userProfileBadge-module-scss-module__F3_wTq__mrl",
  "mrm": "userProfileBadge-module-scss-module__F3_wTq__mrm",
  "mrn": "userProfileBadge-module-scss-module__F3_wTq__mrn",
  "mrs": "userProfileBadge-module-scss-module__F3_wTq__mrs",
  "mrx": "userProfileBadge-module-scss-module__F3_wTq__mrx",
  "mrxl": "userProfileBadge-module-scss-module__F3_wTq__mrxl",
  "mrxxl": "userProfileBadge-module-scss-module__F3_wTq__mrxxl",
  "ms": "userProfileBadge-module-scss-module__F3_wTq__ms",
  "mtl": "userProfileBadge-module-scss-module__F3_wTq__mtl",
  "mtm": "userProfileBadge-module-scss-module__F3_wTq__mtm",
  "mtn": "userProfileBadge-module-scss-module__F3_wTq__mtn",
  "mts": "userProfileBadge-module-scss-module__F3_wTq__mts",
  "mtx": "userProfileBadge-module-scss-module__F3_wTq__mtx",
  "mtxl": "userProfileBadge-module-scss-module__F3_wTq__mtxl",
  "mtxxl": "userProfileBadge-module-scss-module__F3_wTq__mtxxl",
  "mx": "userProfileBadge-module-scss-module__F3_wTq__mx",
  "mxl": "userProfileBadge-module-scss-module__F3_wTq__mxl",
  "mxxl": "userProfileBadge-module-scss-module__F3_wTq__mxxl",
  "pbl": "userProfileBadge-module-scss-module__F3_wTq__pbl",
  "pbm": "userProfileBadge-module-scss-module__F3_wTq__pbm",
  "pbn": "userProfileBadge-module-scss-module__F3_wTq__pbn",
  "pbs": "userProfileBadge-module-scss-module__F3_wTq__pbs",
  "pbx": "userProfileBadge-module-scss-module__F3_wTq__pbx",
  "pbxl": "userProfileBadge-module-scss-module__F3_wTq__pbxl",
  "pbxxl": "userProfileBadge-module-scss-module__F3_wTq__pbxxl",
  "pl": "userProfileBadge-module-scss-module__F3_wTq__pl",
  "pll": "userProfileBadge-module-scss-module__F3_wTq__pll",
  "plm": "userProfileBadge-module-scss-module__F3_wTq__plm",
  "pln": "userProfileBadge-module-scss-module__F3_wTq__pln",
  "pls": "userProfileBadge-module-scss-module__F3_wTq__pls",
  "plx": "userProfileBadge-module-scss-module__F3_wTq__plx",
  "plxl": "userProfileBadge-module-scss-module__F3_wTq__plxl",
  "plxxl": "userProfileBadge-module-scss-module__F3_wTq__plxxl",
  "pm": "userProfileBadge-module-scss-module__F3_wTq__pm",
  "pn": "userProfileBadge-module-scss-module__F3_wTq__pn",
  "prl": "userProfileBadge-module-scss-module__F3_wTq__prl",
  "prm": "userProfileBadge-module-scss-module__F3_wTq__prm",
  "prn": "userProfileBadge-module-scss-module__F3_wTq__prn",
  "prs": "userProfileBadge-module-scss-module__F3_wTq__prs",
  "prx": "userProfileBadge-module-scss-module__F3_wTq__prx",
  "prxl": "userProfileBadge-module-scss-module__F3_wTq__prxl",
  "prxxl": "userProfileBadge-module-scss-module__F3_wTq__prxxl",
  "ps": "userProfileBadge-module-scss-module__F3_wTq__ps",
  "ptl": "userProfileBadge-module-scss-module__F3_wTq__ptl",
  "ptm": "userProfileBadge-module-scss-module__F3_wTq__ptm",
  "ptn": "userProfileBadge-module-scss-module__F3_wTq__ptn",
  "pts": "userProfileBadge-module-scss-module__F3_wTq__pts",
  "ptx": "userProfileBadge-module-scss-module__F3_wTq__ptx",
  "ptxl": "userProfileBadge-module-scss-module__F3_wTq__ptxl",
  "ptxxl": "userProfileBadge-module-scss-module__F3_wTq__ptxxl",
  "px": "userProfileBadge-module-scss-module__F3_wTq__px",
  "pxl": "userProfileBadge-module-scss-module__F3_wTq__pxl",
  "pxxl": "userProfileBadge-module-scss-module__F3_wTq__pxxl",
  "userProfileButton": "userProfileBadge-module-scss-module__F3_wTq__userProfileButton",
});
